import angular from 'angular';
import SockeService from './web-socket.service';

export default angular.module('autoboard.browserFunctions', [SockeService])
  .name;